export const checkOverFlow = el => {
  const curOverflow = el?.style.overflow;
  if (!curOverflow || curOverflow === 'visible') el.style.overflow = 'hidden';
  const isOverflowing =
    el?.clientWidth < el?.scrollWidth || el?.clientHeight < el?.scrollHeight;
  el.style.overflow = curOverflow;

  return isOverflowing;
};

export const getActivePositionOffSetLeft = el => {
  const children = [...el.childNodes];
  const index = children.findIndex(child =>
    child.className.includes('Mui-active')
  );
  const fixedIndex = index > 0 ? index + 1 : 0;
  return {
    offSetLeft: children[fixedIndex].offsetLeft,
    offSetWidth: children[fixedIndex].offsetWidth,
    parentNodeWidth: el.parentNode.offsetWidth,
  };
};

export const getHorizontalCenterPositionLeftBased = measures => {
  const parentContainerCenter = measures.parentNodeWidth / 2;
  const elementCenter = measures.offSetWidth / 2;
  const elementCurrentPosition = measures.offSetLeft;
  return parentContainerCenter - elementCenter - elementCurrentPosition;
};
